import {Injectable} from '@angular/core';
import { ContractStepModel } from '../../../models/contract.model';
import { ContractDataService } from './contract-data.service';
import { CdkDrag} from '@angular/cdk/drag-drop';
import { IRestrictionStepOrder } from '../../graph-konva/models/graph-kn.model-interfaces';
import { IContractDataModel } from '../models/contract-internal-models';
@Injectable({
    providedIn: 'root'
})
export class ContractRestrictionService {
  public dragRoadMapPredicate: any
  public roadMapSteps: ContractStepModel[]=  []
  constructor(
    private contractDataService:ContractDataService,
  ) {
    this.dragRoadMapPredicate = this.checkResctrictionDrag.bind(this)
  }
  checkResctrictionDrag(index: number, drag: CdkDrag<ContractStepModel>):boolean {
    let indexNew = index
    let indexCurrent = drag.data.sort_index!
    let dragStep = drag.data
     let proposedStepOrder = [
        ...this.roadMapSteps.slice(0,indexCurrent),
        ...this.roadMapSteps.slice(indexCurrent+1)
     ]
     proposedStepOrder.splice(indexNew,0,dragStep)
    let res = false
     let restrictions = this.contractDataService.restrictionsPerContract?.filter(rs => rs.guidStep === dragStep.guid)
     res = restrictions.some(rs=>{
      let partOfGroupArray = rs.typeRestriction === 'before' ? 
        proposedStepOrder.slice(indexNew+1, proposedStepOrder.length ) 
        : proposedStepOrder.slice(0, indexNew)
        let violation = false
        violation = partOfGroupArray
        .filter(step => rs.guidsLinkedSteps.includes(step.guid!)).length !== rs.guidsLinkedSteps.length;
        return violation
     })
     return !res
  } 
	prepareRestrictions(contractData: IContractDataModel) {
    let restrictions: IRestrictionStepOrder[] = [];
    let creaditLetters: { payer_guid: string, credit_letter_guid: string, guid: string } [] = [];
    let rmSteps = contractData.contract?.roadmap_active.steps
    this.roadMapSteps = rmSteps!
    if (contractData.contract?.projects && rmSteps) {
      creaditLetters = contractData.contract.projects
      .filter(project => project.credit_letter_guid)
      .map(project => {
        return {
            payer_guid: project.project.guid,
            credit_letter_guid: project.credit_letter_guid,
            guid: rmSteps.find(el => el.target_key === project.credit_letter_guid)?.guid || ''	}	})

      creaditLetters.forEach(letter => {
        let multi_paymentsGuids = rmSteps
            .filter(step => step.target_type === 'multi_payment')
            .map(mp => mp.multi_payment_data?.filter(mp => mp.payer_guid === letter.payer_guid)
                .map(() => mp.guid)) || [];
        let paymentsGuids = rmSteps
            .filter(el => el.target_type === 'payment' && el.payment_data?.payer_guid === letter.payer_guid)
            .map(el => el.guid) || []
        let allpaymentsGuid = [...multi_paymentsGuids.flat(), ...paymentsGuids]
      
        restrictions.push({
          guidStep: letter.guid,
          typeRestriction: 'before',
          guidsLinkedSteps: rmSteps.filter(step => 
                ['multi_payment', 'payment'].includes(step.target_type || 'none') 
                && allpaymentsGuid.includes(step.guid)).map(el => el.guid||'')
        })
        restrictions.filter(rs => rs.typeRestriction === 'before').forEach(res => {
          let paymentSteps = res.guidsLinkedSteps.map(ls => {
            return {
              guidStep: ls,
              typeRestriction: 'after' as 'after' | 'before',
              guidsLinkedSteps: [res.guidStep]
            }
          })
            restrictions.push(...paymentSteps)
        })
      })
    }
    this.contractDataService.restrictionsPerContract = restrictions
	}
}